import React from "react";
import { Container } from "react-bootstrap";
import "./Review.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Navigation } from "swiper";
import { FaQuoteLeft, FaQuoteRight } from "react-icons/fa";
const Review = () => {
  return (
    <div className="review-container section-container">
      <Container>
        <div className="review-wrapper">
        <div className="section-heading text-center">
          <h2>Whats Our Buyer Say</h2>
        </div>
        <Swiper
          slidesPerView={1}
          spaceBetween={10}
          navigation={true}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          modules={[Autoplay, Navigation]}
          className="mySwiper5"
        >
          <SwiperSlide>
            <div className="review text-center">
              <p>
                <FaQuoteLeft />
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Eos
                quod placeat quos iure corporis veritatis at incidunt iusto
                atque repellat hic, ducimus enim excepturi quas molestias
                fugiat, maxime recusandae! Quia, doloribus! Ipsum, incidunt
                beatae ab repudiandae labore mollitia soluta tempora dolor quo
                saepe, id perspiciatis animi? Sit provident fugit eligendi.
                <FaQuoteRight />
              </p>
              <h4>Mark Otto</h4>
              <span>Analyst</span>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="review text-center">
              <p>
                <FaQuoteLeft />
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Eos
                quod placeat quos iure corporis veritatis at incidunt iusto
                atque repellat hic, ducimus enim excepturi quas molestias
                fugiat, maxime recusandae! Quia, doloribus! Ipsum, incidunt
                beatae ab repudiandae labore mollitia soluta tempora dolor quo
                saepe, id perspiciatis animi? Sit provident fugit eligendi.
                <FaQuoteRight />
              </p>
              <h4>Mark Otto</h4>
              <span>Analyst</span>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="review text-center">
              <p>
                <FaQuoteLeft />
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Eos
                quod placeat quos iure corporis veritatis at incidunt iusto
                atque repellat hic, ducimus enim excepturi quas molestias
                fugiat, maxime recusandae! Quia, doloribus! Ipsum, incidunt
                beatae ab repudiandae labore mollitia soluta tempora dolor quo
                saepe, id perspiciatis animi? Sit provident fugit eligendi.
                <FaQuoteRight />
              </p>
              <h4>Mark Otto</h4>
              <span>Analyst</span>
            </div>
          </SwiperSlide>
        </Swiper>
        </div>
      </Container>
    </div>
  );
};

export default Review;
